//import { Actions } from './../entities/dossier';
import { Component, OnInit } from '@angular/core';
import { Dossier, General, Fe, Adm, Actions, Eval, Connaissances, Langue, Adresse, Diplome, Remarques } from '../entities/dossier';
import { AuthService } from '../auth.service';
import { GenericService } from '../generic.service';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { environment } from '../../environments/environment';
import * as _ from 'underscore';
import { NotificationService } from '../notification.service';

@Component({
  selector: 'app-recherche-simple',
  templateUrl: './recherche-simple.component.html',
  styleUrls: ['./recherche-simple.component.css']
})
export class RechercheSimpleComponent implements OnInit {

  public showSpinner : boolean = false;
  public resultLength : number = 7;
  public query: string;
  //public errorMessage: string;
  //public successMessage: string;
  public dataAvailable : boolean;
  public result : any;
  public keyword : string;
  public page : number;
  public total : number ;
  public totalPages;
  public pages;
  public sortDir = -1;//1= 'ASE' -1= DSC

  public candidatureNonValide : boolean = true;
  public reset : boolean;
  public sortKey : string;
  //public MsgError  : string;


 // public actions: Actions;

  constructor(private _authService: AuthService,  private _genericService: GenericService, private _notifyService: NotificationService) { }

  ngOnInit() {

    this.dataAvailable = false;
    this._authService.checkCredentials();

  }

  // Recherche par mot clè
  search(isValid){
    this.reset = false;
    //this.MsgError = "";
    if(isValid){
      this.loadPage(1,this.sortDir,'dateDernierEntretien');
    }else{
      this._notifyService.showError("Tapez au moins un mot à chercher", "Search", 3000)
      /*this.errorMessage = "Tapez au moins un mot à chercher";
      this.MsgError = this.errorMessage;
      this.resetErrorMessage();*/
    }
  }

  success(result){
    this.totalPages = new Array(result.pages);

    this.total = result.pages;

    let startPage: number, endPage: number;

    if (this.total <= 5) {
      startPage = 1;
      endPage = this.total;
      }
      else {
        if (this.page <= 3) {
            startPage = 1;
            endPage = 5;
        }
        else if (this.page + 1 >= this.total) {
                startPage = this.total - 4;
                endPage = this.total;
            } else {
                startPage = this.page - 2;
                endPage = this.page + 2;
            }
    }
    this.pages= _.range(startPage, endPage + 1);

    this.showSpinner = false;

    // date dernière evaluation
    for(let row of result.data){
      let nbrEvals =  row.fe.actions.evals.length;
      if(nbrEvals > 0 ){
        let evaluation = row.fe.actions.evals[nbrEvals - 1];
        row.dateDernierEntretien = evaluation.date.substr(0,10);
      }
    }
    //this.clearMessages();

    this.result = result.data;
    this.dataAvailable = true;
  }

  // Supprimer la recherche par mot clè
  clear(){
    // clear all elements
    this.keyword = '';
    this.candidatureNonValide = true;
    this.reset = true;
   }

   /*clearMessages(){
    this.successMessage = '';
    this.errorMessage = '';
  }*/

  isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
  }
  // Téléchargement des dossiers
  loadPage(index, sortDir, sortKey){
    this.page = index;
      let body = {
        keyword : String(this.keyword).trim(),
        candidatureNonValide : this.candidatureNonValide,
        page :  this.page
      };

      this.showSpinner = true;

      this._genericService.searchWithBody(environment.searchSimpleUrl, body,true,this.sortDir, this.sortKey)
        .subscribe(
          data =>
            this.success(data),
          error => {
            this.showSpinner = false;
            //this.errorMessage = <any>error
          }
        );

  }

  // page suivante
  next(){
    if(this.page < this.total ){
      this.loadPage(this.page+1, this.sortDir,this.sortKey);
    }
  }
  // Page précédante
  previous(){
    if(this.page > 1){
      this.loadPage(this.page-1, this.sortDir,this.sortKey);
    }
  }

  // Tri des résultats par nom
  onSortNomClick(event) {
    let target = event.currentTarget,
      classList = target.classList;
    this.sortKey = 'nom';

    if (classList.contains('fa-chevron-up')) {
      classList.remove('fa-chevron-up');
      classList.add('fa-chevron-down');
      this.sortDir=-1;
      return this.loadPage(1, this.sortDir, this.sortKey);
    } else {
      classList.add('fa-chevron-up');
      classList.remove('fa-chevron-down');
      this.sortDir=1;
      return this.loadPage(this.page, this.sortDir, this.sortKey);
    }
  }

  // Tri des résultats par prenom
  onSortPrenomClick(event) {
    let target = event.currentTarget,
      classList = target.classList;

    this.sortKey = 'prenom';

    if (classList.contains('fa-chevron-up')) {
      classList.remove('fa-chevron-up');
      classList.add('fa-chevron-down');
      this.sortDir=-1;
      return this.loadPage(this.page, this.sortDir, this.sortKey);
    } else {
      classList.add('fa-chevron-up');
      classList.remove('fa-chevron-down');
      this.sortDir=1;
      return this.loadPage(this.page, this.sortDir, this.sortKey);
    }
  }

   // Tri des résultats par note générale
   onSortNoteGeneralClick(event) {
    let target = event.currentTarget,
      classList = target.classList;

    this.sortKey = 'noteGeneral';

    if (classList.contains('fa-chevron-up')) {
      classList.remove('fa-chevron-up');
      classList.add('fa-chevron-down');
      this.sortDir=-1;
      return this.loadPage(this.page, this.sortDir, this.sortKey);
    } else {
      classList.add('fa-chevron-up');
      classList.remove('fa-chevron-down');
      this.sortDir=1;
      return this.loadPage(this.page, this.sortDir, this.sortKey);
    }
  }

  // Tri des résultats par date du dernier entretien
  onSortDateClick(event) {
    let target = event.currentTarget,
      classList = target.classList;

    this.sortKey = 'dateDernierEntretien';

      if (classList.contains('fa-chevron-up')) {
        classList.remove('fa-chevron-up');
        classList.add('fa-chevron-down');
        this.sortDir=-1;
        return this.loadPage(1, this.sortDir, this.sortKey);
      } else {
        classList.add('fa-chevron-up');
        classList.remove('fa-chevron-down');
        this.sortDir=1;
        return this.loadPage(1, this.sortDir, this.sortKey);
      }
  }
 /* resetErrorMessage(){
    setTimeout(()=>{
      this.MsgError = '';
    }, 3000);
  }*/

}



// WEBPACK FOOTER //
// ./src/app/recherche-simple/recherche-simple.component.ts